<!--  Copied from Desp footer code  -->
    <!-- Footer Container -->
    <div id="footer-container">
      <div id="footer-inner-container">

          <!-- Left Container -->
          <div id="footer-left-container">
              <img id="footer-desp-logo" alt="desp-home" src="/logos/desp_logo.svg">
          </div>


        <!-- Central Container -->
        <div id="footer-central-container">
          <a [href]="DESTINATION_EARTH_LINK" target="_blank">
            <img class="footer-logo" alt="destination earth" src="/logos/destination-earth.png">
          </a>
          <a [href]="EU_COMMISSION_LINK" target="_blank">
            <img class="footer-logo" alt="eu commission" src="/logos/funded-by-EU.png">
          </a>
          <a>
            <img class="footer-logo" alt="implemented by" src="/logos/implemented-by.png">
          </a>
          <a [href]="ECMWF_LINK" target="_blank">
            <img class="footer-logo" alt="ecmwf" src="/logos/ecmwf.png">
          </a>
          <a [href]="ESA_LINK" target="_blank">
            <img class="footer-logo" alt="esa" src="/logos/esa.png">
          </a>
          <a [href]="EUMETSAT_LINK" target="_blank">
            <img class="footer-logo" alt="eumetsat" src="/logos/eumetsat.png">
          </a>
        </div>

        <!-- Right Container -->
        <div id="footer-right-container">
          <i data-feather="menu" id="footer-menu-icon"></i>
        </div>
      </div>

      <!-- Footer menu -->
      <div id="footer-menu">
       
        <a *ngIf="CODE_OF_CONDUCT_LINK" class="frame-link" [href]="CODE_OF_CONDUCT_LINK" target="_blank">Code of Conduct</a>
        <a *ngIf="TERMS_AND_CONDITIONS_LINK" class="frame-link" [href]="TERMS_AND_CONDITIONS_LINK" target="_blank">Terms and Conditions</a>
        <a *ngIf="PRIVACY_POLICIES_LINK" class="frame-link" [href]="PRIVACY_POLICIES_LINK" target="_blank">Privacy Policies</a>
        <a *ngIf="LEGAL_NOTICE_LINK" class="frame-link" [href]="LEGAL_NOTICE_LINK" target="_blank">Legal Notice</a>
      
       
        <div class="mobile-link">
          <hr>
          <a class="footer-frame-link" [href]="DESTINATION_EARTH_LINK" target="_blank">
            <img class="mobile-footer-logo" alt="destination earth" src="/logos/destination-earth.png">
          </a>
          <a class="footer-frame-link" [href]="EU_COMMISSION_LINK" target="_blank">
            <img class="mobile-footer-logo" alt="eu commission" src="/logos/funded-by-EU.png">
          </a>
          <a class="footer-frame-link">
            <img class="mobile-footer-logo" alt="implemented by" src="/logos/implemented-by.png">
          </a>
          <a class="footer-frame-link" [href]="ECMWF_LINK" target="_blank">
            <img class="mobile-footer-logo" alt="ecmwf" src="/logos/ecmwf.png">
          </a>
          <a class="footer-frame-link" [href]="ESA_LINK" target="_blank">
            <img class="mobile-footer-logo" alt="esa" src="/logos/esa.png">
          </a>
          <a class="footer-frame-link" [href]="EUMETSAT_LINK" target="_blank">
            <img class="mobile-footer-logo" alt="eumetsat" src="/logos/eumetsat.png">
          </a>
        </div>
      </div>
    </div>
  